module.exports = __webpack_public_path__ + "assets/img/B-7ec707f9.png";